import { REDUCERS } from 'config/reducers';

const ROOT_URL = 'https://summariser.econsult.awshealth.net';

export const STRINGS = {
  ENVIRONMENT: {
    IS_TEST_ENV: process.env.REACT_APP_ENVIRONMENT === 'unittest' || process.env.REACT_APP_TEST_MODE === 'true',
    IS_DEV_OR_TEST_ENV:
      process.env.REACT_APP_ENVIRONMENT !== 'production' && process.env.REACT_APP_ENVIRONMENT !== 'unittest',
    IS_LOCAL: process.env.REACT_APP_ENVIRONMENT === undefined,
  },
  PUSHER: {
    APP_KEY: '1e850a7121511938033e',
    CHANNEL_ID: 'my-channel',
    CLUSTER: 'eu',
  },
  TRANSCRIBE: {
    SAMPLE_RATE_HERTZ: 16000,
    MAX_RECORDING_TIME_SECONDS: 3600,
    MAX_WARNING_TIME_SECONDS: 3000,
  },
  SUMMARISER: {
    BASE_URL: ROOT_URL,
    HOST: `${ROOT_URL}/summariser`,
    WEBSOCKET: 'ws://summariser.econsult.awshealth.net/summariser',
  },
  TOOLBAR: {
    ROLE: 'TOOLBAR',
  },
  ROOT_URL,
  AUTH: {
    HOST: `${ROOT_URL}/auth`,
  },
  USER_MANAGEMENT: {
    HOST: `${ROOT_URL}/usermanagement`,
  },
  SMART_INBOX: {
    HOST: 'https://inbox.econsult.health/workflow/home',
  },
  E_LITE: {
    HOST: 'https://elite.econsult.awshealth.net',
  },
  SETTINGS: {
    HOST: 'https://settings.econsult.awshealth.net',
  },
  REPORTING: {
    HOST: 'https://inbox.econsult.health/workflow/reports',
  },
  CUSTOMISATION: {
    HOST: 'https://api.econsult.health/customisation',
    FEATURE_GROUP: 'SUMMARISER_FRONTEND_FEATURE_FLAGS',
    FEATURE_FLAGS: {
      SUMMARISER_EMIS_INTEGRATION_ENABLED: 'SUMMARISER_EMIS_INTEGRATION_ENABLED',
      TEMP_SUMMARISER_SNOMED_ENABLED: 'TEMP_SUMMARISER_SNOMED_ENABLED',
      SUMMARISER_SEND_FEEDBACK_ENABLED: 'SUMMARISER_SEND_FEEDBACK_ENABLED',
      AI_SNOMED_CODES_ENABLED: 'AI_SNOMED_CODES_ENABLED',
      SUMMARISER_COPILOT_ENABLED: 'SUMMARISER_COPILOT_ENABLED',
      SUMMARISER_TEMPLATE_MANAGER_ENABLED: 'SUMMARISER_TEMPLATE_MANAGER_ENABLED',
      TEMP_SUMMARISER_PAYMENT_ENABLED: 'TEMP_SUMMARISER_PAYMENT_ENABLED',
      ENABLE_SHOW_WELCOME_MODAL: 'ENABLE_SHOW_WELCOME_MODAL',
      SUMMARISER_MANUAL_SNOMED_ENABLED: 'SUMMARISER_MANUAL_SNOMED_ENABLED',
    },
  },
  REDUCERS,
  SESSION: {
    REFRESH_AFTER: 1000 * 60 * 30,
    LOGOUT_AFTER: 1000 * 60 * 60,
    REFRESH_INTERVAL: 1000 * 60,
  },
  DATADOG: {
    ID: 'pubab9cd6d45649d03eef11c681ec22c076',
  },
  INTERCOM: {
    ENABLED: true,
    APP_ID: 'wmmrp56d', // eConsult Health [TEST]
  },
  FRESHPAINT: {
    ENABLED: false,
    ID: '',
  },
  TOKEN: {
    JWT_AUTH_SECRET: 'htsyv098dpcly65kn6sh9d60lihpmtqccn3v6univppnosjjuvzhsmvo3ypoturs',
  },
  USER: {
    ROLE: {
      CLINICAL_SYSTEM_EMIS: 'CLINICAL_SYSTEM_EMIS',
      CLINICAL_SYSTEM_S1: 'CLINICAL_SYSTEM_S1',
      CLINICAL_SYSTEM_NONE: 'CLINICAL_SYSTEM_NONE',
    },
    IDENTITY: {
      NONE: 'NONE',
      BROWSER: 'BROWSER',
      TOOLBAR: 'TOOLBAR',
    },
  },
  INTEROP: {
    INITIAL_DRAFT_COPY: 'An initial draft of this consultation summary was generated by eConsult Hi Scribe. \n',
    NAME: { S1: 'S1', EMIS: 'EMIS' },
    USER_ROLE_TO_INTEROP_NAME: {
      CLINICAL_SYSTEM_EMIS: 'EMIS',
      CLINICAL_SYSTEM_S1: 'S1',
      CLINICAL_SYSTEM_NONE: 'NONE',
    },
    SNOMED: {
      EMIS_BMI_UNIT: 'kg/m2',
      S1_BMI_UNIT: 'Kg/m&#178;',
    },
  },
  REQUEST_STATUS: {
    IDLE: 'IDLE',
    PENDING: 'PENDING',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
  },
  TEMPLATE: {
    API_URL: 'https://api.testing-x.econsult.awshealth.net/messaging2',
    TEMPLATE_API_URL: 'https://api.dev.message-template.qhealth.io/v1',
    TEMPLATE_TYPE: {
      PERSONAL: 'PERSONAL',
      SHARED: 'SHARED',
      PUBLIC: 'PUBLIC',
      ALL: 'ALL',
    },
    DEFAULT_TEMPLATE_NAME: 'Default template',
    EMIS_WEB_TEMPLATE: 'EMIS Web template',
  },
  STRIPE: {
    PUBLISHABLE_KEY: 'SETUP_PER_ENV',
  },
};
